import { useTitle } from 'react-use';

import InsuranceTypes from 'pages/SignUp/insurance/InsuranceTypes';
import InsuranceTypeExtended from 'pages/SignUp/WM/InsuranceTypeExtended';

import { MixedSignupStepProps } from 'containers/SignUp/Content/content.types';
import { AdditionalConditions } from 'containers/SignUp/signUp.types';

import { FlowTypes } from 'utils/enums';

const InsuranceTypeStepWrapper: React.FC<
  MixedSignupStepProps & {
    onHandleAdditionalConditions: (type: AdditionalConditions, value: boolean) => void;
  }
> = ({ moveToStep, selectedFlow, onHandleAdditionalConditions }) => {
  useTitle('LifeMD - Insurance type');

  switch (selectedFlow) {
    case FlowTypes.WeightManagementFlowInsuranceAlt:
      return (
        <InsuranceTypes onContinue={(v: boolean) => onHandleAdditionalConditions('insurance', v)} />
      );
    default:
      return (
        <InsuranceTypeExtended
          selectedFlow={selectedFlow}
          onCancel={() => moveToStep(-1)}
          onComplete={() => moveToStep('next')}
        />
      );
  }
};

export default InsuranceTypeStepWrapper;
